export const API_HTTP = {
	// Local dev: .env.development sets REACT_APP_API_URL=http://localhost:8080
	// Deployed: empty env var → "/api", which nginx proxies to the server
	// (see client/.nginx/default.conf.template). Image is environment-agnostic.
	resumeAnalyzer: process.env.REACT_APP_API_URL || "/api"
} as const;

export enum resumeAnalyzerApiEndpoints {
	user = "/user",
	userSubscriptionStats = "/user/subscription-stats",
	jobs = "/user/jobs",
	jobDetails = "/user/jobs/{jobId}",
	resume = "/user/resume",
	resumeUpload = "/user/resume/upload",
	resumeGenerate = "/user/resume/generate",
	coverLetter = "/user/cover-letter",
	coverLetterById = "/user/cover-letter/{coverLetterId}",
	orders = "/user/orders",
	linkedinLogin = "/linkedin-login",
	referrals = "/user/referrals",
	jobHistory = "/user/jobs/{jobId}/history",
	jobNotes = "/user/jobs/{jobId}/notes",
	jobNoteDelete = "/user/jobs/{jobId}/notes/{noteId}",
	userContacts = "/user/contacts",
	jobContacts = "/user/jobs/{jobId}/contacts",
	jobContactDelete = "/user/jobs/{jobId}/contacts/{contactId}",
	jobThankYou = "/user/jobs/{jobId}/thank-you",
	jobFollowUp = "/user/jobs/{jobId}/follow-up",
	referralValidate = "/user/referrals/validate/{code}",
	referralRedeem = "/user/referrals/{code}/redeem",
	referralCredits = "/user/referrals/credits",
	referralCatalog = "/user/referrals/credits/catalog",
	referralPurchase = "/user/referrals/credits/purchase",
	referralMyReferrer = "/user/referrals/my-referrer",
	referralOriginatorSummary = "/user/referrals/my-originator-summary",
	referralRevoke = "/user/referrals/{code}"
}
